import React from 'react';
import { connect } from 'react-redux';

const ResetButton = (props) => {
  return (
    <button
      className={props.className || 'ResetBtn'}
      onClick={() => {
        props.dispatch({
          type: props.action,
        });
      }}
    >{props.label || 'RESET'}</button>
  );
};

export default connect()(ResetButton);
